import React, { useEffect, useRef, useState } from 'react'
// import { LoadingOutlined } from '@ant-design/icons'
import nprogress from 'nprogress';
import styles from './index.module.less'
import "nprogress/nprogress.css";
import Logo from './images/loading.png'
import Logo2 from './images/loading2.png'
import { DatePicker, Form, FormInstance, FormItemProps, FormProps, Input, InputNumber, InputNumberProps, Modal, ModalProps, Radio, RadioChangeEvent, Select, SelectProps, TreeSelect, Upload, UploadFile, UploadProps } from 'antd';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';
import { Catch, Tools } from '../../utils';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { RcFile, UploadChangeParam } from 'antd/es/upload';
import { baseUrl } from '../../api';
import Ueditor, { IUeditorProps } from '../Ueditor';
import moment from 'moment';
import InputColor from './InputColor';

export const LuckLoading: React.FC = () => {
	return (
		<div className={styles.loadBox}>
			<div className={styles.loading}>
				{/* <LoadingOutlined className={styles.loadingicon} /> */}
				<div className={styles.loadingLogo}>
					<div className={styles.loadingLogo1}>
						<img src={Logo} alt='美中科技' />
					</div>
					<div className={styles.loadingLogo2}>
						<img src={Logo2} alt='美中科技' />
					</div>
				</div>
			</div>
		</div>
	)
}

export const LuckProgress: React.FC<{ children?: React.ReactNode }> = ({ children = null }) => {
	useEffect(() => {
		nprogress.start();
		return () => {
			nprogress.done()
		}
	}, [])
	return (<>
		{children}
	</>)
}

export type ILuckFormItem = React.PropsWithChildren<{
	type: 'input' | 'select' | 'uploadImage' | 'radio' | 'text' | 'radioInput' | 'number' | 'ueditor' | 'treeSelect' | 'date' | 'datetime' | 'color' | 'password';
	name: string; //'eq__'
	label: string;
	hidden?: boolean;
	disabled?: boolean;
	placeholder?: string;
	initValue?: string | number;
	rules?: {
		required: boolean,
		message: string
	}[];
	upload?: {
		formRef?: React.RefObject<FormInstance<any>>,
		formData?: any;
		count: number;
		path: string;
	};
	options?: {
		value?: number | string;
		text?: number | string;
		name?: string;
		label?: string;
		id?: number | string;
	}[];
	rows?: number;
	formItemOption?: ILuckFormItem;
	changeValue?: number | string;
	formRef?: React.RefObject<FormInstance>;
	changeEmpty?: boolean;
	numberProp?: InputNumberProps;
	selectProp?: SelectProps;
	formItemProps?: FormItemProps;
	ueditorProps?: IUeditorProps;
	optionValue?: 'value' | 'name' | 'label' | 'id' | 'text';
	optionLabel?: 'value' | 'name' | 'label' | 'id' | 'text';
	tip?: string;
}>
export const LuckFormItem = ({ type, name, label, hidden, disabled, placeholder, initValue, rules, upload, rows, options, formItemOption, changeValue, formRef, changeEmpty,
	numberProp,
	formItemProps,
	ueditorProps,
	optionLabel,
	optionValue,
	selectProp,
	tip,
	children
}: ILuckFormItem) => {
	const [nameValue, setNameValue] = useState<{ [key: string]: any }>({});
	const [changeBool, setChangeBool] = useState(false);
	const contentRef = useRef();

	const radioInputChange = (e: RadioChangeEvent, name: string, changeValue?: string | number, name2?: string) => {
		let newNameValue = { ...nameValue };
		newNameValue[name] = e.target.value
		if (changeValue !== e.target.value && changeEmpty) {
			formRef && formRef.current?.setFieldValue(name2 as string, '');
		}
		setNameValue(newNameValue)
	}

	useEffect(() => {
		if (formItemOption) {
			setTimeout(() => {
				setChangeBool(!(nameValue[name] !== undefined ? nameValue[name] === changeValue : (formRef?.current?.getFieldValue(name) !== undefined ? formRef?.current?.getFieldValue(name) === changeValue : initValue === changeValue)))
			}, 0)
		}
	}, [nameValue, formRef, changeValue, name, initValue, formItemOption])

	const changeContent = (e: any, fieldName: string) => {
		let con = e;
		con = con.replace(/crossorigin="anonymous"/g, '');
		formRef && formRef.current?.setFieldValue(fieldName, con);
	}

	const onChangeColor = (e: any, fieldName: string) => {
		formRef && formRef.current?.setFieldValue(fieldName, e);
	}
	switch (type) {
		case 'input':
			return (<Form.Item
				label={label}
				name={name}
				hidden={!!hidden}
				rules={rules && rules.length > 0 ? rules : []}
				initialValue={initValue ?? initValue}
				{...formItemProps}
			>
				<Input disabled={!!disabled} placeholder={placeholder} />
			</Form.Item>)
		case 'password':
			return (<Form.Item
				label={label}
				name={name}
				hidden={!!hidden}
				rules={rules && rules.length > 0 ? rules : []}
				initialValue={initValue ?? initValue}

			>
				<Input.Password disabled={!!disabled} placeholder={placeholder} />
			</Form.Item>)
		case 'number':
			return (<Form.Item
				label={label}
				name={name}
				hidden={!!hidden}
				rules={rules && rules.length > 0 ? rules : []}
				initialValue={initValue ?? initValue}
				{...formItemProps}
			>
				<InputNumber disabled={!!disabled} placeholder={placeholder} style={{ width: '100%' }} {...numberProp} />
			</Form.Item>)
		case 'uploadImage':
			return (<>
				<Form.Item
					label={label}
					name={name}
					hidden={true}
					{...formItemProps}
				>
					<Input disabled={true} />
				</Form.Item>
				<LuckUploadImage
					extra={formItemProps?.extra}
					label={label}
					formRef={upload?.formRef as React.RefObject<FormInstance<any>>}
					formData={upload?.formData}
					fieldName={name}
					maxCount={upload?.count as number}
					path={upload?.path as string}
				/>
			</>)
		case 'radio':
			return (
				<Form.Item
					label={label}
					name={name}
					initialValue={initValue ?? initValue}
					rules={rules && rules.length > 0 ? rules : []}
					{...formItemProps}
				>
					<Radio.Group disabled={!!disabled}>
						{
							options?.map(((item, index) => {
								return <Radio.Button key={index} value={item.value}>{item.label}</Radio.Button>
							}))
						}
					</Radio.Group>
				</Form.Item>
			)
		case 'text':
			return (<Form.Item
				label={label}
				name={name}
				hidden={!!hidden}
				rules={rules && rules.length > 0 ? rules : []}
				initialValue={initValue ?? initValue}
				{...formItemProps}
			>
				<Input.TextArea rows={rows as number} disabled={!!disabled} placeholder={placeholder} />
			</Form.Item>)
		//下拉
		case 'select':
			return (
				<Form.Item
					label={label}
					name={name}
					initialValue={initValue ?? initValue}
					rules={rules && rules.length > 0 ? rules : []}
					{...formItemProps}
				>
					<Select placeholder={placeholder} disabled={!!disabled} {...selectProp}>
						{
							options && options.length > 0 ?
								options.map((item: any) => <Select.Option key={optionValue ? item[optionValue] : item.id} value={optionValue ? item[optionValue] : item.id}>{optionLabel ? item[optionLabel] : item.name}</Select.Option>)
								: null
						}
					</Select>
				</Form.Item>
			)
		case 'treeSelect':
			return (
				<Form.Item
					label={label}
					name={name}
					initialValue={initValue ?? initValue}
					rules={rules && rules.length > 0 ? rules : []}
					{...formItemProps}
				>
					<TreeSelect
						style={{ width: '100%' }}
						value={initValue}
						dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
						treeData={options}
						placeholder={placeholder}
						treeDefaultExpandAll
						fieldNames={{
							label: optionLabel ? optionLabel : 'name'
							, value: optionValue ? optionValue : 'value'
						}}
					/>
				</Form.Item>
			)
		//radio联动input
		case 'radioInput':
			return (<>
				<Form.Item
					label={label}
					name={name}
					initialValue={initValue ?? initValue}
					rules={rules && rules.length > 0 ? rules : []}
					{...formItemProps}
				>
					<Radio.Group disabled={!!disabled} onChange={(e: RadioChangeEvent) => radioInputChange(e, name, changeValue, formItemOption ? formItemOption['name'] : '')}>
						{
							options?.map(((item, index) => {
								return <Radio.Button key={index} value={item.value}>{item.label}</Radio.Button>
							}))
						}
					</Radio.Group>
				</Form.Item>
				{
					formItemOption ?
						(
							<LuckFormItem
								{...formItemOption}
								hidden={changeBool}
								rules={!changeBool ? formItemOption['rules'] : []}
							/>
						) : null
				}
			</>)
		case 'ueditor':
			return (<Form.Item
				label={label}
				name={name}
				hidden={!!hidden}
				rules={rules && rules.length > 0 ? rules : []}
				initialValue={initValue ?? initValue}
				{...formItemProps}
			>
				<Ueditor
					ref={contentRef}
					ajaxUrl={baseUrl}
					width='100%'
					height='400'
					autoHeight={false}
					inModal={false}
					toolbarsType='all'
					handleChange={(e: any) => changeContent(e, name)}
					content={initValue}
					{...ueditorProps}
				/>
			</Form.Item>)
		case 'date':
			const indata = initValue ? Tools.numToTime(initValue as number, 'YYYY-mm-dd') : Tools.numToTime(0, 'YYYY-mm-dd')
			const inittime = moment(indata, 'YYYY-MM-DD')
			return (
				<Form.Item
					label={label}
					name={name}
					rules={rules && rules.length > 0 ? rules : []}
					initialValue={inittime}
					{...formItemProps}
				>
					<DatePicker placement='bottomLeft' />
				</Form.Item>
			)
		case 'datetime':
			const indata2 = initValue ? Tools.numToTime(initValue as number, 'YYYY-mm-dd HH:MM:SS') : Tools.numToTime(0, 'YYYY-mm-dd HH:MM:SS')
			const inittime2 = moment(indata2, 'YYYY-MM-DD HH:mm:ss')
			return (
				<Form.Item
					label={label}
					name={name}
					rules={rules && rules.length > 0 ? rules : []}
					initialValue={inittime2}
					{...formItemProps}
				>
					<DatePicker placement='bottomLeft' showTime />
				</Form.Item>
			)
		case 'color':
			return (
				<Form.Item
					label={label}
					name={name}
					rules={rules && rules.length > 0 ? rules : []}
					initialValue={initValue ?? initValue}
					{...formItemProps}
				>
					{/* <Input hidden={true}  /> */}
					<InputColor value={initValue ? initValue as string : ''} colorChange={(e: any) => onChangeColor(e, name)} />
				</Form.Item>
			)
		default:
			return null
	}

}

/**
 * ==========================================
 * 自定义表单
 * ==========================================
 */
type ITableForm = React.PropsWithChildren<{
	onSubmit?: Function,
	// formRef?: React.RefObject<FormInstance>,formRef, 
	initialValues?: any,
	formProps?: FormProps
}>
export const LuckForm = React.forwardRef(({ onSubmit, initialValues, formProps, children }: ITableForm, ref: any) => {
	const [form] = Form.useForm();

	const onFinish = () => {
		onSubmit && onSubmit(form)
	}
	const onFinishFailed = () => {

	}
	return <>
		<Form
			ref={ref}
			name="basic"
			form={form}
			labelCol={{ span: 8 }}
			wrapperCol={{ span: 16 }}
			initialValues={initialValues}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete="off"
			{...formProps}
		>
			{children}
		</Form>
	</>
})


/**
 * ==========================================
 * 弹出窗口
 * ==========================================
 */
type IModelProps = React.PropsWithChildren<{
	title: string,
	okText?: string,
	width?: number,
	modalOk?: Function,
	modalCancel?: Function,
	modalProps?: ModalProps,
	styles?: React.CSSProperties,
	open: boolean
}>
export interface IRef {
	openModal?: Function
	closeModal?: Function,
}
export const LuckModal = ({ title, width, modalOk, modalCancel, okText = '保存', open, modalProps, children, styles }: IModelProps) => {
	const [disabled, setDisabled] = useState(false);
	const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
	const draggleRef = useRef<HTMLDivElement>(null);
	const btnLoading = useSelector((state: RootState) => state.main.btnLoading)

	const handleOk = (e: React.MouseEvent<HTMLElement>) => {
		// console.log(e);
		// setOpen(false);
		modalOk && modalOk()
	};

	const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
		modalCancel && modalCancel();
	};

	const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
		const { clientWidth, clientHeight } = window.document.documentElement;
		const targetRect = draggleRef.current?.getBoundingClientRect();
		if (!targetRect) {
			return;
		}
		setBounds({
			left: -targetRect.left + uiData.x,
			right: clientWidth - (targetRect.right - uiData.x),
			top: -targetRect.top + uiData.y,
			bottom: clientHeight - (targetRect.bottom - uiData.y),
		});
	};
	return (<>
		{/* form表单 */}
		<Modal
			centered
			title={
				<div
					style={{
						width: '100%',
						cursor: 'move',
					}}
					onMouseOver={() => {
						if (disabled) {
							setDisabled(false);
						}
					}}
					onMouseOut={() => {
						setDisabled(true);
					}}
					onFocus={() => { }}
					onBlur={() => { }}
				>
					{title}
				</div>
			}
			okText={okText}
			open={open}
			onOk={handleOk}
			onCancel={handleCancel}
			okButtonProps={
				{
					disabled: btnLoading,
					loading: btnLoading
				}
			}
			modalRender={modal => (
				<Draggable
					disabled={disabled}
					bounds={bounds}
					onStart={(event, uiData) => onStart(event, uiData)}
				>
					<div ref={draggleRef}>{modal}</div>
				</Draggable>
			)}
			width={width ? width : 600}
			destroyOnClose
			{...modalProps}
			bodyStyle={{ overflowY: 'auto', maxHeight: '80vh', ...styles }}
		>
			{children}
		</Modal>
	</>)
}



/**
 * 上传
 */

type IUpload = React.PropsWithChildren<{
	label: string,
	formRef: React.RefObject<FormInstance<any>>,
	fieldName: string;
	maxCount: number;
	formData?: any;
	path: string;
	extra?: React.ReactNode
}>

export const LuckUploadImage = ({ label, formRef, fieldName, maxCount, formData, path, extra, children }: IUpload) => {

	const [loading, setLoading] = useState(false);
	const [imageUrl, setImageUrl] = useState<string[]>([]);
	const [fileList, setFileList] = useState<UploadFile[]>([]);

	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('');

	const beforeUpload = (file: RcFile) => {
		const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
		if (!isJpgOrPng) {
			Tools.error('上传图片类型不正确 JPG/PNG!');
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			Tools.error('上传图片超过 2MB!');
		}
		return isJpgOrPng && isLt2M;
	};
	const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
		// setFileList(info.fileList.slice())
		const nlist = Object.assign([], info.fileList)
		if (info.file.status === 'uploading') {
			setLoading(true);
		}
		if (info.file.status === 'done') {
			setLoading(false);
			let files = info.fileList;
			for (let i = 0; i < files.length; i++) {
				const ff = files[i];
				if (ff.status === 'done' && ((ff.response && ff.response.code === 0) || !ff.response)) {
					if (ff.response) {
						if (imageUrl.indexOf(ff.response.data.url) <= -1) {
							if (imageUrl.length >= maxCount) {
								let imgs = [...imageUrl];
								imgs.splice(0, 1);
								setImageUrl([...imgs, ff.response.data.url])
							} else {
								setImageUrl([...imageUrl, ff.response.data.url])
							}
						}
					}
				}
			}
		}
		setFileList(nlist)
	};
	const uploadButton = (
		<div>
			{loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div style={{ marginTop: 8 }}>Upload</div>
		</div>
	);

	//查看图片
	const handlePreview = async (file: UploadFile) => {
		let url = file.url || (file.preview as string);
		if (file.response && file.response.code === 0) {
			url = Tools.imgUrl(file.response.data.url)
		}

		setPreviewImage(url);
		setPreviewOpen(true);
		setPreviewTitle(file.name || url!.substring(url!.lastIndexOf('/') + 1));
	};
	const handleCancel = () => setPreviewOpen(false);

	const onRemove = (file: UploadFile) => {

		if (file.url) {
			const index = imageUrl.indexOf(file.uid);
			let imgs = [...imageUrl];
			imgs.splice(index, 1);
			setImageUrl(imgs)
		}

		if (file.response && file.response.code === 0) {
			const index = imageUrl.indexOf(file.response.data.url);
			let imgs = [...imageUrl];
			imgs.splice(index, 1);
			setImageUrl(imgs)
		}
	};

	useEffect(() => {
		formRef && formRef.current?.setFieldValue(fieldName, imageUrl.join(';'))
	}, [fieldName, formRef, imageUrl])
	useEffect(() => {
		const arr = (formData && formData[fieldName] && formData[fieldName].length > 0) ? formData[fieldName].split(';') : [];
		const files: UploadFile<any>[] = [];
		for (let i = 0; i < arr.length; i++) {
			files.push({
				uid: arr[i],
				name: arr[i],
				status: 'done',
				url: Tools.imgUrl(arr[i]),
			})
		}
		if (arr.length > 0) {
			setFileList(files)
			setImageUrl(arr)
		} else {
			setFileList([])
			setImageUrl([])
		}
	}, [fieldName, formData])

	return (
		<>
			<Form.Item label={label}
				extra={extra}
			>
				<Form.Item noStyle>
					<Upload
						name="file"
						listType="picture-card"
						className="avatar-uploader"
						// showUploadList={false}
						action={baseUrl + 'api/uploadImage'}
						beforeUpload={beforeUpload}
						onChange={handleChange}
						headers={{
							Authorization: Catch.get('access_token')
						}}
						data={{
							path: path
						}}
						onPreview={handlePreview}
						onRemove={onRemove}
						maxCount={maxCount}
						multiple={maxCount > 1}
						fileList={fileList}
					>
						{imageUrl.length < maxCount ? uploadButton : null}
					</Upload>
				</Form.Item>
			</Form.Item>
			<Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
				<img alt="" style={{ width: '100%' }} src={previewImage} />
			</Modal>
		</>
	)
}